// R13: static foreground solids shared by visuals and gameplay.
// Edge stones deduct mood on impact; the shelter tree is solid but emotionally neutral.
import {applyMoodEvent} from './mood-system.js';

const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
export const EDGE_ROCKS=Object.freeze([
 {id:'edge-0',x:-3.70,z:2.90,scale:1.50},{id:'edge-1',x:-4.00,z:-.50,scale:1.30},
 {id:'edge-2',x:3.95,z:.80,scale:1.60},{id:'edge-3',x:2.60,z:-3.95,scale:1.30},
 {id:'edge-4',x:-1.60,z:-4.00,scale:1.10},{id:'edge-5',x:1.20,z:4.00,scale:1.05},
 {id:'edge-6',x:-3.50,z:3.70,scale:.50},{id:'edge-7',x:3.65,z:2.60,scale:.60},
 {id:'edge-8',x:-2.40,z:3.95,scale:.30},{id:'edge-9',x:-3.90,z:1.90,scale:.40},
 {id:'edge-10',x:3.80,z:-2.80,scale:.50}
].map(o=>Object.freeze({...o,radius:Math.max(.13,o.scale*.34),kind:'stone',moodEvent:'stone'})));
export const TREE_COLLIDER=Object.freeze({id:'tree-trunk',x:-3.28,z:-2.38,radius:.30,kind:'tree',moodEvent:null});
export const STATIC_OBSTACLE_BLUEPRINTS=Object.freeze([...EDGE_ROCKS,TREE_COLLIDER]);

export function createStaticObstacles(){
 return STATIC_OBSTACLE_BLUEPRINTS.map(o=>({...o,touching:false,lastHit:-100}));
}
export function resetStaticObstacles(list){for(const o of list){o.touching=false;o.lastHit=-100;}return list;}

function resolveOne(player,o,{mood=null,time=0,events=true}={}){
 let dx=player.x-o.x,dz=player.z-o.z,d=Math.hypot(dx,dz),rr=player.radius+o.radius;
 if(d>rr+.055){if(events)o.touching=false;return null;}
 if(d>=rr)return null;
 if(d<1e-8){dx=1;dz=0;d=1;}
 const nx=dx/d,nz=dz/d,impact=Math.max(0,-player.vx*nx-player.vz*nz);
 player.x=o.x+nx*(rr+.00005);player.z=o.z+nz*(rr+.00005);
 if(impact>0){
  const tree=o.kind==='tree',rebound=tree?clamp(.30+impact*.48,.38,1.45):clamp(.46+impact*.58,.52,2.05);
  player.vx+=nx*(impact+rebound);player.vz+=nz*(impact+rebound);
  if(impact>.08)player.recoil=Math.max(player.recoil||0,tree?.12:.17);
 }
 if(!events)return null;
 let event=null;
 if(!o.touching&&impact>.075&&time-o.lastHit>.55){
  const moodApplied=o.moodEvent&&mood?applyMoodEvent(mood,o.moodEvent):false;
  o.lastHit=time;
  event={type:o.kind==='tree'?'tree':'stone',source:'static',id:o.id,x:o.x+nx*o.radius,z:o.z+nz*o.radius,nx,nz,strength:clamp(.28+impact*.22,.28,1),moodApplied};
 }
 o.touching=true;return event;
}

export function resolveStaticCollisions(player,obstacles,opts={}){
 const out=[];
 for(let pass=0;pass<3;pass++)for(const o of obstacles){const event=resolveOne(player,o,opts);if(event)out.push(event);}
 return out;
}
